<template>
  <div id="app">
    <div id="Return_Bar">
      <i class="el-icon-arrow-left"></i>
      <div @click="isreturn" class="isreturn">返回</div>
    </div>
    <div id="text" style="text-align:center;width:100%;">
      <div style="width:80%;margin-left:10%;min-height:800px;padding-bottom:30px;background-color: #fff">
          <div style="text-align:left;width:80%;margin-left:10%">
              <br>
              <div style="font-size: 16px;margin:30px 0px 0px 20px;"><b>本次测试的项目场景为“<span style="color:#4978F2">{{randomScript.title}}</span>”，请尽快熟悉以下资料并了解测试要求：</b></div>
              <div style="font-size: 16px;margin:20px 0px 0px 20px;background-color: #F2F2F2;min-height:170px;padding:10px 20px 10px 20px;">
                  <div><b>项目介绍</b></div>
                  <div>{{randomScript.intro}}</div>
              </div>
              <div style="font-size: 16px;margin:20px 0px 0px 20px;background-color: #F2F2F2;min-height:170px;padding:10px 20px 10px 20px;">
                  <div><b>参考话术</b></div>
                  <div style="font-size: 14px;" v-html="randomScript.script"></div>
              </div>
              <div style="font-size: 16px;margin:20px 0px 0px 20px;background-color: #F2F2F2;min-height:170px;padding:10px 20px 10px 20px;">
                  <div><b>测试要求</b></div>
                  <div style="font-size: 14px;" v-html="randomScript.asking"></div>
              </div>
              <div style="font-size: 18px;margin:20px 0px 0px 20px;padding:10px 20px 10px 20px;text-align:center">
                  <div style="font-weight:bold;" v-if="seconds > 0">
                      <div style="float:left;margin-left:38%;width:80px;">测试将在</div>
                      <div style="float:left;width:100px;height:30px;border-radius: 6px;background-color: #AAA;padding-top:2px;margin:0px 5px 0px 5px">{{time}}</div>
                      <div style="float:left">后开始</div>
                  </div>
                  <div style="font-weight:bold;" v-else>
                      <div style="float:left;margin-left:38%;width:80px;">&nbsp;</div>
                      <div @click="goKaohe" style="float:left;font-size:15px;width:100px;height:30px;border-radius: 6px;background-color: #69f;color:#f7f7f7;padding-top:2px;margin:0px 5px 0px 5px">开始测试</div>
                  </div>
              </div>
          </div>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CallOutRandomScript",
  data() {
    return {
      courseId:this.$route.query.courseId,
      assitantType:this.$route.query.assitantType,
      businessMajorId:this.$route.query.businessMajorId,
      sceneId:this.$route.query.sceneId,
      trainId:this.$route.query.trainId,
      tjkId:this.$route.query.tjkId,
      seconds: 1*60 ,//1min，给客服的准备时间
      time:null,
      randomScript:{//随机考核话术
          show:false,
          relId:null,
          asking:null,
          courseId:null,
          intro:null,
          script:null,
          title:null
      }
    };
    
  },
  created(){
      this.showRandomScript();
      this.startTime();
  },
  mounted(){
  },
  methods: {
      // 返回按钮
      isreturn() {
          this.$router.go(-1)
      },
      // 返回按钮
      goKaohe() {
          if(this.randomScript == null){
              this.$message({message: '未配置随机脚本',type: 'warning',center: true,duration: 2500});
              return;
          }
          localStorage.setItem('do_toKaoheDetail', 'true');
          this.$router.push({
              path: "/train/SpecialCourses",
              query: {
                  courseId: this.courseId,
                  assitantType: this.assitantType,
                  businessMajorId: this.businessMajorId,
                  sceneId: this.sceneId,
                  trainId: this.trainId,
                  tjkId: this.tjkId,
                  scriptRelId: this.randomScript.relId,
              }
          });
      },

      showRandomScript() {
          var self = this;
          this.$http.post(API_ROOT.college + '/courseTjcollege/randomScript', {"trainId":this.trainId}).then(response => {
              var result = response.data;
              if (result.success) {
                  self.randomScript = result.data;
                  if(self.randomScript == null){
                      this.$message({message: '随机脚本为空，刷新一下缓存或联系管理员',type: 'warning',center: true,duration: 2500});
                  }
              } else {
                  this.$alert(result.msg)
              }
          }, response => {
              this.$alert('AJAX访问接口异常！');
          })
      },
      startTime() {
          var self = this
          //若是我(prd,test)或者海建（prd,test）则设定3秒
          if(self.tjkId == 558306 || self.tjkId == 8715266 || self.tjkId == 1434675 || self.tjkId == 8716027){
              self.seconds = 3;
          }
          var timer = setInterval(function() {
             self.seconds--
              if(self.seconds >= 0) {
                  var sec = parseInt(self.seconds)
                  var min = 0
                  var hour = 0
                  if(sec > 60) {
                      min = parseInt(sec/60)
                      sec = parseInt(sec%60)
                      if(min > 60) {
                          hour = parseInt(min/60)
                          min = parseInt(min%60)
                      }
                  }
                  hour = hour < 10 ? "0" + hour : hour
                  min = min < 10 ? "0" + min : min
                  sec = sec < 10 ? "0" + sec : sec
                  if(hour > 0 ) {
                      self.time = `${hour}:${min}:${sec}`
                  }else {
                      self.time =`${min}:${sec}`
                  }
              }else {
                  clearInterval(timer)
                  self.time = '时间到'
              }
          },1000);
      }
  }
  
};
</script>
<style lang='less' scoped>
.isreturn{color:#000;cursor: pointer;}
/deep/.el-icon-arrow-left{color: #000;}
.step-list{margin-bottom: 20px;background:#fff;border-radius:5px ;padding: 19px 20px 20px 60px;position: relative;}
.step-list_top{display: flex;justify-content: space-between;}
.list_top_left{display: flex;}
.list_top_left{font-size: 16px;color: #262626;font-weight: bold;position: relative;left: -20px;}
/deep/.el-button--small{padding: 9px 24px !important;border-radius:6px;}
/deep/.el-button--primary{background-color: #497af2;}
.step-list_under{margin-top: 15px;background: #f5f6f7;padding: 19px 20px 20px 19px;font-size: 13px;overflow: hidden;color:#262626;}
.circle{width: 20px;height: 20px;background:#497AF2;border-radius: 20px;position: relative;z-index: 1;display: inline-flex;justify-content: center;align-items: center;transition: 0.15s ease-out;left: -20px;top:2px;color: #fff;font-weight: normal;line-height: 20px;}
.othercircle{width: 20px;height: 20px;background:#BBBBBB;border-radius: 20px;position: relative;z-index: 1;display: inline-flex;justify-content: center;align-items: center;transition: 0.15s ease-out;left: -20px;top:2px;color: #fff;font-weight: normal;line-height: 20px;}
.line{
    width: 2px;

    top:41px;
    bottom: -20px;
    left: 29px;
    position: absolute;
    border-color: inherit;
    background-color: #1684fc;
    z-index: 99;}
.otherline{
    width: 2px;

    top:41px;
    bottom: -20px;
    left: 29px;
    position: absolute;
    border-color: inherit;
    background-color: #BBBBBB;
    z-index: 99;}
#app {
  height: 100%;
  box-sizing: border-box;
}
#Return_Bar {
  padding-left: 21px;
  display: flex;
  padding-top: 10px;
  padding-bottom: 15px;
  width: 100%;
}
/deep/.el-icon-arrow-left {
  margin-top: 5px;
}
#text {
  background: #f6f5f8;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
}
#text .right {
  width: 100%;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// ./src/page/train/newservice/CallOutRandomScript.vue